import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import 'cfa-react-components/dist/styles.min.css';
import 'styles/reset.css';
import 'styles/global.scss';
import * as FontAwesome from 'styles/fontAwesomeIcons';
import { App } from './App';

axios.defaults.baseURL = process.env.REACT_SERVER_BASE_URL_LOCAL

FontAwesome.init();

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    document.getElementById('app')
);
